export default __webpack_public_path__ + "static/media/RedSide.eeaf43ec.svg";